var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 14,
  viewBox: "0 0 10 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M-0.000244141 0V14H9.99976V0H-0.000244141ZM8.99976 13H0.999756V1H8.99976V13ZM6.99976 11.9998H2.99976V10.9998H6.99976V11.9998Z",
  fill: "currentColor"
})));
export { SvgMobile as ReactComponent };
export default __webpack_public_path__ + "assets/icons/mobile.561582.svg";